import { useEffect } from 'react';

/**
 * A hook which listens for pressed keys
 * @param {string[]} keys Collection of key name
 * @param {Function} callback Callback when it matches with one of the key
 * @example
 * useKeyPress(['Escape', 'Enter'], (event) => console.log(event.key));
 */
export function useKeyPress(keys: string[], callback?: (event: KeyboardEvent) => void) {
  useEffect(() => {
    if (!callback) return;

    const onKeyPress = (event: KeyboardEvent) => {
      if (keys.includes(event.key)) callback(event);
    };

    window.addEventListener('keyup', onKeyPress);

    return () => {
      window.removeEventListener('keyup', onKeyPress);
    };
  }, [callback]);
}
